import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {UrlService} from '../../services/url.service';
import {SettingsIntegrationsService} from '../../services/settings-integrations.service';
import {flatMap, takeUntil, tap} from 'rxjs/operators';

@Component({
    templateUrl: 'settings-integrations.component.html'
})
export class SettingsIntegrationsComponent implements OnInit, OnDestroy {

    constructor(public settingsIntegrationsService: SettingsIntegrationsService,
                public urlService: UrlService) {
    }

    ngOnInit() {
        this.settingsIntegrationsService.getBuildings();
        this.settingsIntegrationsService.firstTimeLoading = true;

        this.urlService.onUrlChange
            .pipe(
                tap(
                    () => {
                        this.settingsIntegrationsService.tabId = this.urlService.queryParams['tab'];
                        this.settingsIntegrationsService.showDetailedView = false;
                        this.settingsIntegrationsService.selectedItemData = null;
                    }
                ),
                flatMap(
                    () => this.settingsIntegrationsService.getCorporationsByQueryParams().pipe(takeUntil(this.urlService.instantOnUrlChange))
                )
            )
            .subscribe();
        this.urlService.setQueryParams('allSettingsAmenities');
    }

    ngOnDestroy() {
        this.removeAllObservers();
        this.settingsIntegrationsService.resetData();
        this.urlService.resetQueryParams();
    }

    removeAllObservers() {
        this.urlService.onUrlChange.observers = [];
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.settingsIntegrationsService.emptyRowService.fillEmptyRow();
    }
}





// WEBPACK FOOTER //
// /app/src/app/views/settings-integrations/settings-integrations.component.ts